const PASSWORD_RECOVERED_STORAGE_KEY = 'passwordRecoveredAt';

export const notifyPasswordRecovered = () => {
  localStorage.setItem(PASSWORD_RECOVERED_STORAGE_KEY, String(Date.now()));
};

export const onPasswordRecoveredInOtherTab = (callback: () => void) => {
  const onStorage = (event: StorageEvent) => {
    if (event.key === PASSWORD_RECOVERED_STORAGE_KEY && event.newValue) {
      callback();
    }
  };

  window.addEventListener('storage', onStorage);
  return () => window.removeEventListener('storage', onStorage);
};
